import script from "./artifact-card.vue?vue&type=script&setup=true&lang=js"
export * from "./artifact-card.vue?vue&type=script&setup=true&lang=js"

import "./artifact-card.vue?vue&type=style&index=0&id=4671d4e4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4671d4e4"]])

export default __exports__